import type { WorkPostSheetFormValues } from '../providers/FormProvider'
import { WorkPostSheetItemTypesEnum } from '../types'

export enum WorkPostSheetFormStep {
  Step1,
  Step2,
  Step3,
  Step4,
  Overview
}

export const WPS_FORM_STEPS = [
  WorkPostSheetFormStep.Step1,
  WorkPostSheetFormStep.Step2,
  WorkPostSheetFormStep.Step3,
  WorkPostSheetFormStep.Step4,
  WorkPostSheetFormStep.Overview
]

// Items per checkbox group, in the order they are shown in the form and in the overview.
// Item labels are translated with `work_post_sheet_form.<item name in lowercase>.label`.
export const WORK_CLOTHES_AND_PROTECTIVE_EQUIPMENT_ITEMS = [
  WorkPostSheetItemTypesEnum.GLASSES_SAFETY_SCREEN,
  WorkPostSheetItemTypesEnum.MASK,
  WorkPostSheetItemTypesEnum.PANTS_OVERALL,
  WorkPostSheetItemTypesEnum.DUST_JACKET,
  WorkPostSheetItemTypesEnum.HEARING_PROTECTION,
  WorkPostSheetItemTypesEnum.SAFETY_BELT_HARNESS,
  WorkPostSheetItemTypesEnum.GLOVES_MITTENS,
  WorkPostSheetItemTypesEnum.SAFETY_SHOES,
  WorkPostSheetItemTypesEnum.HELMET,
  WorkPostSheetItemTypesEnum.OINTMENTS,
  WorkPostSheetItemTypesEnum.COAT,
  WorkPostSheetItemTypesEnum.OTHER_EQUIPMENT
]

export const REQUIRED_VACCINATIONS_AND_TESTS_ITEMS = [
  WorkPostSheetItemTypesEnum.TETANUS,
  WorkPostSheetItemTypesEnum.TUBERCULOSE,
  WorkPostSheetItemTypesEnum.HEPATITIS_B,
  WorkPostSheetItemTypesEnum.OTHER_VACCINATIONS_TESTS
]

export const HEALTH_RISKS_ITEMS = [
  WorkPostSheetItemTypesEnum.SAFETY_FUNCTION,
  WorkPostSheetItemTypesEnum.FUNCTION_WITH_INCREASED_VIGILANCE,
  WorkPostSheetItemTypesEnum.NIGHT_WORK,
  WorkPostSheetItemTypesEnum.HANDLING_LOADS,
  WorkPostSheetItemTypesEnum.SHIFT_WORK,
  WorkPostSheetItemTypesEnum.CHEMICAL_AGENTS,
  WorkPostSheetItemTypesEnum.BIOLOGICAL_AGENTS,
  WorkPostSheetItemTypesEnum.NOISE,
  WorkPostSheetItemTypesEnum.ERGONOMIC_LOAD,
  WorkPostSheetItemTypesEnum.YOUNGER
]

export const MATERNITY_PROTECTION_MEASURES_ITEMS = [
  WorkPostSheetItemTypesEnum.PREGNANCY_ADJUSTMENTS,
  WorkPostSheetItemTypesEnum.PREGNANCY_ADJUSTMENTS_DATE,
  WorkPostSheetItemTypesEnum.BREASTFEEDING_ADJUSTMENTS,
  WorkPostSheetItemTypesEnum.BREASTFEEDING_ADJUSTEMENTS_DATE
]

export const DATES_OF_ADVICE_ITEMS = [
  WorkPostSheetItemTypesEnum.ADVICE_DATE,
  WorkPostSheetItemTypesEnum.ADVICE_BY_COMITE_PWB,
  WorkPostSheetItemTypesEnum.ADVICE_BY_SYNDICATE_REP,
  WorkPostSheetItemTypesEnum.ADVICE_BY_DIRECT_EMPLOYEE_PARTICIPATION,
  WorkPostSheetItemTypesEnum.ADVICE_DATE_LABOR_DOCTOR,
  WorkPostSheetItemTypesEnum.ADVICE_DATE_INTERNAL_SERVICE
]

// Used to navigate to the first step with a validation error.
// Keep in sync with the fields rendered by each step.
export const WPS_FORM_STEP_FIELDS: Record<
  Exclude<WorkPostSheetFormStep, WorkPostSheetFormStep.Overview>,
  (keyof WorkPostSheetFormValues)[]
> = {
  [WorkPostSheetFormStep.Step1]: [
    'uploadOwnWPS',
    'newPdfCommentAttachment',
    'tasksToPerform',
    'requiredQualifications',
    'workEquipment',
    'priorInstructions',
    'foreseeableTraining',
    'workstationLocation',
    'welcomeOfficer',
    'welcomeOfficerPosition'
  ],
  [WorkPostSheetFormStep.Step2]: [],
  [WorkPostSheetFormStep.Step3]: [],
  [WorkPostSheetFormStep.Step4]: ['maternityProtectionMeasuresRequired']
}

export const WPS_FORM_STEP_ITEMS: Record<
  Exclude<WorkPostSheetFormStep, WorkPostSheetFormStep.Overview>,
  WorkPostSheetItemTypesEnum[]
> = {
  [WorkPostSheetFormStep.Step1]: [],
  [WorkPostSheetFormStep.Step2]: WORK_CLOTHES_AND_PROTECTIVE_EQUIPMENT_ITEMS,
  [WorkPostSheetFormStep.Step3]: [
    ...REQUIRED_VACCINATIONS_AND_TESTS_ITEMS,
    ...HEALTH_RISKS_ITEMS
  ],
  [WorkPostSheetFormStep.Step4]: [
    ...MATERNITY_PROTECTION_MEASURES_ITEMS,
    ...DATES_OF_ADVICE_ITEMS
  ]
}
